
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tAfaViewWaveOrder/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tAfaViewWaveOrder/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tAfaViewWaveOrder/findPage',
        method: 'post',
      data
    })
}

// 批量选择
export const handleSelect = (data) => {
  return axios({
    url: '/tAfaViewWaveOrder/handleSelect',
    method: 'post',
    data
  })
}

// 取消批量选择
export const handleUnselect = (data) => {
  return axios({
    url: '/tAfaViewWaveOrder/handleUnselect',
    method: 'post',
    data
  })
}

// 添加订单到波次
export const addOrder = (data) => {
  return axios({
    url: '/tAfaViewWaveOrder/addOrder',
    method: 'post',
    data
  })
}

// 从波次移除订单
export const removeOrder = (data) => {
  return axios({
    url: '/tAfaViewWaveOrder/removeOrder',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tAfaViewWaveOrder.js